import { parseV2Timestamp } from './v2DateTime';

const invalidHistory = () => new Error('레이팅 이력 응답 형식을 확인할 수 없습니다.');

/** v2 이력의 순서와 점수를 보존한다. 이름·연락처·문제 목록은 저장하지 않는다. */
export function normalizeRatingHistory(data, studentId) {
  if (!data || (studentId !== undefined && (!Number.isInteger(data.student_id)
      || data.student_id <= 0 || data.student_id !== Number(studentId))) || !Number.isInteger(data.rating)
      || !Number.isInteger(data.exam_count) || data.exam_count < 0
      || !Array.isArray(data.exams) || data.exams.length !== data.exam_count) throw invalidHistory();

  const seen = new Set();
  let previousTime = -Infinity;
  const exams = data.exams.map((exam) => {
    const time = parseV2Timestamp(exam?.closed_at)?.getTime();
    const key = `${exam?.exam_kind}:${exam?.exam_id}`;
    if (!exam || !['legacy', 'paper_v2'].includes(exam.exam_kind)
        || !Number.isInteger(exam.exam_id) || exam.exam_id <= 0
        || !Number.isInteger(exam.rating) || !Number.isInteger(exam.delta)
        || time == null || time < previousTime || seen.has(key)) throw invalidHistory();
    seen.add(key);
    previousTime = time;
    return {
      exam_id: exam.exam_id, exam_kind: exam.exam_kind,
      exam_type: exam.exam_type,
      exam_round: exam.exam_round, paper_revision: exam.paper_revision,
      closed_at: exam.closed_at, rating: exam.rating, delta: exam.delta,
      problem_count: exam.problem_count, correct: exam.correct,
      wrong: exam.wrong, unanswered: exam.unanswered,
    };
  });
  if (data.rating !== (exams.length ? exams[exams.length - 1].rating : 1000)) throw invalidHistory();
  // 공유 응답은 studentCard의 학생 번호를 마스킹하므로 이 새 필드에도 원본 학생 번호를 넣지 않는다.
  return { rating: data.rating, exam_count: data.exam_count, exams };
}

/** 저장된 구 형식도 지원한다. API 조회 없이 저장 당시 레이팅만 표시한다. */
export function buildRatingView(ratingV2, legacyExams = []) {
  if (ratingV2 !== undefined) {
    try {
      const history = normalizeRatingHistory(ratingV2);
      const series = history.exams.map((exam, index) => ({
        examRound: index + 1, rating: exam.rating, change: exam.delta,
        closedAt: exam.closed_at, examId: exam.exam_id, examKind: exam.exam_kind,
      }));
      return {
        source: 'v2', status: 'ready', series, current: history.rating,
        change: series.length ? series[series.length - 1].change : null,
        examCount: history.exam_count,
      };
    } catch (_) {
      return { source: 'v2', status: 'error', series: [], current: null, change: null, examCount: null };
    }
  }

  // 과거 리포트에 저장된 값은 당시 표시 규칙까지 유지한다. 구 API를 다시 호출하지 않는다.
  const series = (legacyExams || [])
    .filter((exam) => Number.isFinite(exam.rating) && exam.rating > 0 && exam.rating !== 1000)
    .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
    .map((exam, index, all) => ({
      examRound: index + 1, rating: exam.rating,
      change: index > 0 ? exam.rating - all[index - 1].rating : null,
    }));
  const last = series[series.length - 1];
  return {
    source: 'legacy-snapshot', status: 'ready', series,
    current: last?.rating ?? null, change: last?.change ?? null, examCount: series.length,
  };
}
